export default {"src":"/_next/static/media/eye_64.f118e4ac.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};